var chunkMapping = {
	"src_bootstrap_js-webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/container/remote/CommonModules/CookieUtils",
		"webpack/container/remote/CommonModules/Utils",
		"webpack/container/remote/CommonModules/Configs",
		"webpack/container/remote/CommonModules/CommonConfigContext",
		"webpack/container/remote/CommonModules/enLanguageFile",
		"webpack/container/remote/CommonModules/BIDashboardSidebar",
		"webpack/container/remote/CommonModules/UnderConstruction",
		"webpack/container/remote/CommonModules/UserSetting",
		"webpack/container/remote/CommonModules/Header",
		"webpack/container/remote/CommonModules/EmptyLabel",
		"webpack/container/remote/CommonModules/DateRangePicker",
		"webpack/container/remote/CommonModules/AIPDFGenerate",
		"webpack/container/remote/CommonModules/AISummary",
		"webpack/container/remote/CommonModules/Select",
		"webpack/container/remote/CommonModules/HighChart",
		"webpack/container/remote/CommonModules/RenderTableHeaderValue",
		"webpack/container/remote/CommonModules/RenderTableCellValue",
		"webpack/container/remote/CommonModules/ReactDataTable",
		"webpack/container/remote/CommonModules/StockChart",
		"webpack/container/remote/CommonModules/Forbidden",
		"webpack/container/remote/CommonModules/NotFound",
		"webpack/container/remote/CommonModules/TokenExpirationMonitor"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/CommonModules/CookieUtils": [
		"default",
		"./CookieUtils",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/Utils": [
		"default",
		"./Utils",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/Configs": [
		"default",
		"./Configs",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/CommonConfigContext": [
		"default",
		"./CommonConfigContext",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/enLanguageFile": [
		"default",
		"./enLanguageFile",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/BIDashboardSidebar": [
		"default",
		"./BIDashboardSidebar",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/UnderConstruction": [
		"default",
		"./UnderConstruction",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/UserSetting": [
		"default",
		"./UserSetting",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/Header": [
		"default",
		"./Header",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/EmptyLabel": [
		"default",
		"./EmptyLabel",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/DateRangePicker": [
		"default",
		"./DateRangePicker",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/AIPDFGenerate": [
		"default",
		"./AIPDFGenerate",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/AISummary": [
		"default",
		"./AISummary",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/Select": [
		"default",
		"./Select",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/HighChart": [
		"default",
		"./HighChart",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/RenderTableHeaderValue": [
		"default",
		"./RenderTableHeaderValue",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/RenderTableCellValue": [
		"default",
		"./RenderTableCellValue",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/ReactDataTable": [
		"default",
		"./ReactDataTable",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/StockChart": [
		"default",
		"./StockChart",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/Forbidden": [
		"default",
		"./Forbidden",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/NotFound": [
		"default",
		"./NotFound",
		"webpack/container/reference/CommonModules"
	],
	"webpack/container/remote/CommonModules/TokenExpirationMonitor": [
		"default",
		"./TokenExpirationMonitor",
		"webpack/container/reference/CommonModules"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}